site.isotope = {
	init: function() {
		const $grid = $('.coursesContainer').isotope({
			itemSelector: '.course',
			layoutMode: 'fitRows',
			getSortData: {
				category: '[data-category]',
			}
		});

		$('#filters').on( 'click', 'button', function() {
			let filterValue = $(this).attr('data-filter');
			$grid.isotope({ filter: filterValue });
		});

		$('.filter__buttons').each(function(i, buttonGroup) {
			const $buttonGroup = $(buttonGroup);
			$buttonGroup.on( 'click', 'button', function() {
				$buttonGroup.find('.selected').removeClass('selected');
				$(this).addClass('selected');
			});
		});
	}
};

site.inits.push('site.isotope.init()');
